/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cdo_Col_RecipientInputs */

const vi_cdo_col_recipient = /** @type {(inputs: Cdo_Col_RecipientInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Người nhận`)
};

/**

* @param {Cdo_Col_RecipientInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const cdo_col_recipient = /** @type {((inputs?: Cdo_Col_RecipientInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cdo_Col_RecipientInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cdo_col_recipient(inputs)
});